<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            requiredFrom: requiredFrom$ | async,
            requiredTo: requiredTo$ | async
        } as data"
    >
        <ng-container *ngIf="titleKey">
            <h6 class="bazis-form__group-title">
                {{ t(titleKey, titleParams) }}
                <span
                    color="danger"
                    *ngIf="data.requiredFrom"
                >
                    *
                </span>
                <bazis-interrogation
                    *ngIf="tooltipKey"
                    iconSize="compact"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipOffset]="[-8, 4]"
                    [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                    [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                    [icon]="icons.interrogation"
                    [type]="interrogationType"
                ></bazis-interrogation>
            </h6>
        </ng-container>
        <bazis-grid
            class="bazis-grid_form"
            [style.--bazis-grid-columns]="widthForm === 'full' ? '8' : '12'"
        >
            <bazis-row class="bazis-datetime-control">
                <bazis-col
                    sizeXs="8"
                    sizeSm="4"
                    [sizeSm]="!isInterval.value || !isInterval.value.length ? 8 : 4"
                    [class.bh-no-padding]="!isInterval.value || !isInterval.value.length"
                >
                    <div
                        #dateInputFrom
                        clickOutside
                        (clickOutside)="clickPopperFromOutside()"
                        [excludeElement]="calendarPopperFrom"
                    >
                        <div [class]="'bazis-control ' + cssClassSizeControl">
                            <bazis-label
                                *ngIf="fromTitleKey && isInterval?.value"
                                [title]="t(fromTitleKey, fromTitleParams)"
                                [required]="data.requiredFrom"
                            >
                            </bazis-label>

                            <div
                                class="bazis-control__field-group bh-pointer"
                                [class.bazis-control__field-group--disabled]="disabled"
                                (click)="openDateCalendarFrom($event)"
                            >
                                <bazis-control-field-start
                                    *ngIf="placeIcon === 'left'"
                                    [icon]="icons.date"
                                >
                                </bazis-control-field-start>

                                <div class="bazis-control__field-wrapper">
                                    <div class="bazis-control__field">
                                        {{ value.value.from }}
                                    </div>
                                </div>

                                <bazis-control-field-end
                                    [icon]="placeIcon === 'right' ? icons.date : ''"
                                    [canEraserShow]="true"
                                    [value]="value.value.from"
                                    (erased)="onClearFrom()"
                                >
                                </bazis-control-field-end>
                            </div>

                            <div class="bazis-control__error">
                                <bazis-form-error
                                    [validationErrorMessages]="validationErrorMessages"
                                    [formControl]="value.controls.from"
                                ></bazis-form-error>
                                <bazis-display-error
                                    errorKey="invalidIntervalDate"
                                    *ngIf="value.errors?.invalidIntervalDate"
                                ></bazis-display-error>

                                <!-- для ошибок родительского контрола
    (пример использоавния в input-text-array, предполагается сюда "вложить" bazis-form-error) -->
                                <ng-content></ng-content>
                            </div>

                            <div
                                *ngIf="noteKey || showIntervalCheckbox"
                                class="bazis-control__note"
                            >
                                <p *ngIf="noteKey">{{ t(noteKey, noteParams) }}</p>

                                <bazis-input-options
                                    *ngIf="showIntervalCheckbox"
                                    [formControl]="isInterval"
                                    [options]="isIntervalOptions"
                                    (touched)="markAsTouched()"
                                    captionEmpty=""
                                ></bazis-input-options>
                            </div>
                        </div>

                        <div
                            #calendarPopperFrom
                            class="bh-popper-z-index"
                            [hidden]="!showCalendarFrom"
                            (click)="clickPopperFrom()"
                        >
                            <bazis-datepicker
                                *ngIf="showCalendarFrom"
                                [value]="calendarValue"
                                [minDate]="minDate"
                                [maxDate]="maxDate"
                                [calendarsNumber]="1"
                                [marks$]="marks$"
                                [viewConfig]="datapickerViewConfig"
                                (valueChange)="setValueFromCalendar($event)"
                            ></bazis-datepicker>
                        </div>
                    </div>
                </bazis-col>
                <bazis-col
                    sizeXs="8"
                    sizeSm="4"
                    [hidden]="!isInterval.value || !isInterval.value.length"
                >
                    <div
                        #dateInputTo
                        clickOutside
                        (clickOutside)="clickPopperToOutside()"
                        [excludeElement]="calendarPopperTo"
                    >
                        <div [class]="'bazis-control ' + cssClassSizeControl">
                            <bazis-label
                                *ngIf="toTitleKey"
                                [title]="t(toTitleKey, toTitleParams)"
                                [required]="data.requiredTo"
                            >
                            </bazis-label>

                            <div
                                class="bazis-control__field-group bh-pointer"
                                [class.bazis-control__field-group--disabled]="disabled"
                                (click)="openDateCalendarTo($event)"
                            >
                                <bazis-control-field-start
                                    *ngIf="placeIcon === 'left'"
                                    [icon]="icons.date"
                                >
                                </bazis-control-field-start>

                                <div class="bazis-control__field-wrapper">
                                    <div class="bazis-control__field">
                                        {{ value.value.to }}
                                    </div>
                                </div>

                                <bazis-control-field-end
                                    [icon]="placeIcon === 'right' ? icons.date : ''"
                                    [canEraserShow]="true"
                                    [value]="value.value.to"
                                    (erased)="onClearTo()"
                                >
                                </bazis-control-field-end>
                            </div>

                            <div class="bazis-control__error">
                                <bazis-form-error
                                    [validationErrorMessages]="validationErrorMessages"
                                    [formControl]="value.controls.to"
                                ></bazis-form-error>

                                <ng-content></ng-content>
                            </div>
                        </div>

                        <div
                            #calendarPopperTo
                            class="bh-popper-z-index"
                            [hidden]="!showCalendarTo"
                            (click)="clickPopperTo()"
                        >
                            <bazis-datepicker
                                *ngIf="showCalendarTo"
                                [value]="calendarValue"
                                [minDate]="minDate"
                                [maxDate]="maxDate"
                                [calendarsNumber]="1"
                                [marks$]="marks$"
                                [viewConfig]="datapickerViewConfig"
                                (valueChange)="setValueFromCalendar($event)"
                            ></bazis-datepicker>
                        </div>
                    </div>
                </bazis-col>
            </bazis-row>

            <!-- <bazis-row *ngIf="noteKey">
                <bazis-col size="8">
                    <div>{{ t(noteKey, noteParams) }}</div>
                </bazis-col>
            </bazis-row> -->
        </bazis-grid>
    </ng-container>
</ng-container>
